import React from 'react';
import classNames from 'classnames';

import styles from './Button.module.scss';

export enum ButtonColor {
  DEFAULT = 'DEFAULT',
  LIGHT = 'LIGHT',
  WHITE = 'WHITE',
  TRANSPARENT = 'TRANSPARENT',
}

interface ButtonProps {
  width?: string;
  height?: string;
  color?: ButtonColor;
  onClick?: (args?: any) => void;
  borderRadius?: string;
  disabled?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps & React.HTMLAttributes<HTMLButtonElement>> = ({
  width,
  height,
  color,
  onClick,
  borderRadius,
  disabled,
  className,
  children,
  ...restProps
}) => {
  const getButtonColor = (colorValue: ButtonColor | undefined): string => {
    switch (colorValue) {
      case ButtonColor.LIGHT:
        return styles.ButtonWithUnderlay__Color_light;
      case ButtonColor.WHITE:
        return styles.ButtonWithUnderlay__Color_white;
      case ButtonColor.TRANSPARENT:
        return styles.ButtonWithUnderlay__Color_transparent;
      default:
        return styles.ButtonWithUnderlay__Color_default;
    }
  };

  const getFontColor = (colorValue: ButtonColor | undefined): string => {
    if (colorValue === ButtonColor.DEFAULT || !colorValue) {
      return styles.fontColorWhite;
    }
    return styles.fontColorLight; // styles.fontColorBlack;
  };

  const isDisabled = (disabledValue: boolean | undefined): string => {
    return disabledValue ? 'not-allowed' : 'pointer';
  };

  return (
    <button
      className={classNames(
        styles.ButtonWithUnderlay,
        getButtonColor(color),
        getFontColor(color),
        className
      )}
      style={{ width, height, borderRadius, cursor: isDisabled(disabled) }}
      onClick={onClick}
      disabled={disabled}
      {...restProps}
    >
      {children}
    </button>
  );
};

export default Button;
